<!--div class="col-md-12" *ngFor="let tree of treeModels">
  <tree #treeComponent [tree]="tree"
  (nodeSelected)="handleSelected($event)"
  (nodeRemoved)="handleRemoved($event)"
  (nodeRenamed)="handleRenamed($event)"
  (nodeMoved)="handleMoved($event)"
  (nodeCreated)="handleCreated($event)"
  (nodeExpanded)="handleExpanded($event)"
  (nodeCollapsed)="handleCollapsed($event)"
  (loadNextLevel)="handleNextLevel($event)">
  </tree>
</div-->
<tree-root #tree [nodes]="treeModels" [options]="options"></tree-root>